import { render, staticRenderFns } from "./dbspDetails.vue?vue&type=template&id=0962cab6&scoped=true"
import script from "./dbspDetails.vue?vue&type=script&lang=js"
export * from "./dbspDetails.vue?vue&type=script&lang=js"
import style0 from "./dbspDetails.vue?vue&type=style&index=0&id=0962cab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962cab6",
  null
  
)

export default component.exports